import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import TopicsSection from '@/pages/home/components/SectionTopics';
import SectionCarousel from '@/pages/home/components/SectionCarousel';
import SectionApp from '@/pages/home/components/SectionApp';
import SectionContact from '@/pages/home/components/SectionContact';
import SectionMedia from '@/pages/home/components/SectionMedia';
import SectionFaq from '@/pages/home/components/SectionFaq';
import SectionFeatures from '@/pages/home/components/SectionFeatures';
import SectionAbout from '@/pages/home/components/SectionAbout';
import SectionIndex from '@/pages/home/components/SectionIndex';
import SectionUpdates from '@/pages/home/components/SectionUpdates';
import SectionComments from '@/pages/home/components/SectionComments';
import SectionRanking from '@/pages/home/components/SectionRanking';
import SectionCards from '@/pages/home/components/SectionCards';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <SectionCarousel />
        <SectionApp />
        <SectionContact />
        <SectionMedia />
        <SectionFaq />
        <SectionFeatures />
        <SectionAbout />
        <SectionIndex />
        <SectionUpdates />
        <SectionComments />
        <SectionRanking />
        <SectionCards />
      </main>
      <Footer />
    </>
  );
}